module.exports = __webpack_public_path__ + "img/uppassword.43ff3b35.svg";